import React from 'react';
import { Form } from '../../../ui/universe';
import { getSelectRectKey, getWarnList } from '../utils';

/** 枚举模式下的结果中文映射 */
const ENUM_MEANINGS = { pass: '通过', reject: '不通过' };

const cell = (value) => {
  if (value === undefined) return '未返回';
  if (value === null) return 'null';
  return String(value);
};

/**
 * 解析自定义推理结果的展示文案
 * enum 取 EnumValue，string 取 TextValue；均未返回时按原值展示
 */
const getReasoningText = (reasoning) => {
  if (!reasoning || typeof reasoning !== 'object') return cell(reasoning);
  const { OutputMode, EnumValue, TextValue } = reasoning;
  const value = OutputMode === 'enum' ? EnumValue : OutputMode === 'string' ? TextValue : undefined;
  if (OutputMode !== 'enum') return cell(value);
  if (value === '**UNCERTAIN**' || value === '__UNCERTAIN__') return `无法确定（${value}）`;
  if (ENUM_MEANINGS[value]) return `${ENUM_MEANINGS[value]}（${value}）`;
  return cell(value);
};

/**
 * Risk 渲染器 - 风险/鉴伪结果展示
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {Object} props.request - 本次请求参数（用于判断是否开启自定义推理）
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 */
const RiskRenderer = ({ params, config, request, selectRect, onSelect }) => {
  const riskList = getWarnList(params);

  // 自定义推理结果：仅当本次请求传入了推理规则时展示
  const reasoningSent = !!(request?.ReasoningPrompt && String(request.ReasoningPrompt).trim());
  const reasoning = params?.[config?.reasoningKey || 'ReasoningResult'];
  const showReasoningValue = reasoningSent && reasoning !== undefined;
  const showReasoningEmpty = reasoningSent && reasoning === undefined && !params?.error;
  const showReasoning = showReasoningValue || showReasoningEmpty;

  if (riskList.length === 0 && !showReasoning) {
    return <div style={{ paddingLeft: '22px', paddingTop: '10px' }}>未检测到待告警信息</div>;
  }

  return (
    <>
      <Form.Item label="">鉴伪结果：</Form.Item>
      {riskList.map((item, index) => {
        const selectRectVal = getSelectRectKey({
          data: item,
          key: '',
          valStr: `${item.key}-${item[config.riskNum]}`
        });
        const warnInfo = config.warnsList?.[item.key];

        return (
          <Form.Item
            key={`risk-${index}`}
            active
            label={`${index + 1}、风险程度-${warnInfo?.warnTitle || item.key}`}
            className={`${selectRect && selectRect === selectRectVal ? 'isSelect' : ''} unv-form__item-group`}
            onClick={() => {
              onSelect && onSelect(item.key, selectRectVal);
            }}
          >
            <p className="mb-10">
              <span>{item[config.riskNum]}{warnInfo?.tips ? `,${warnInfo.tips}` : ''}</span>
              {warnInfo?.content && params?.[warnInfo.content] && <span>{`:${params[warnInfo.content]}`}</span>}
            </p>
          </Form.Item>
        );
      })}
      {riskList.length === 0 && showReasoning && (
        <div style={{ paddingLeft: '22px', paddingTop: '10px' }}>未提示鉴伪风险</div>
      )}
      {showReasoning && (
        <Form.Item
          active
          label={`${riskList.length + 1}、${config?.reasoningTitle || '自定义推理结果'}`}
          className="unv-form__item-group"
        >
          <p className="mb-10">
            <span>
              {showReasoningEmpty ? '未返回推理结果，请查看 Response' : getReasoningText(reasoning)}
            </span>
          </p>
        </Form.Item>
      )}
    </>
  );
};

export default RiskRenderer;
